/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import Favorite from "@mui/icons-material/Favorite";

import styles from "./Footer.module.scss";

export default function Footer(props) {
  const { children, content, theme, big, className } = props;
  const themeType =
    theme === "transparent" || theme == undefined ? false : true;
  const footerClasses = classNames(
    styles.footer,
    className,
    {
      [styles[theme]]: themeType,
      [styles.big]: big || children !== undefined,
    }
  );

  return (
    <footer className={footerClasses}>
      <div className={styles.container}>
        {children !== undefined ? (
          <div>
            <div className={styles.content}>{children}</div>
            <hr />
          </div>
        ) : (
          " "
        )}
        {content}
        <div className={styles.clearFix} />
      </div>
    </footer>
  );
}

Footer.propTypes = {
  theme: PropTypes.oneOf(["dark", "white", "transparent"]),
  big: PropTypes.bool,
  content: PropTypes.node.isRequired
};
